<template>
  <CModal
      :show.sync="removeGradeModal"
      :centered="true"
      title="حذف نمره"
      size="md"
  >
    آیا مطمئن هستید؟

    <template #footer>
      <CButton @click="OnRemoveMark" color="primary" :loading="loading"
      >حذف
      </CButton
      >
      <CButton @click="removeGradeModal = false" color="gray-800">
        انصراف
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  props: {
    value: {
      type: Boolean,
    },
    mark: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    removeGradeModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    async OnRemoveMark() {
      try {
        this.loading = true;
        await axios.delete(`mark/${this.mark.examMarkId}`);
        this.removeGradeModal = false;
        this.$emit("get-mark");
        this.$emit('get-exam')
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>